import { atom } from "recoil";

export const CurrentPageTitle = atom<string | undefined>({
  key: "currentPageTitle",
  default: undefined,
  dangerouslyAllowMutability: true,
});
